var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 39,
    viewBox: "0 0 44 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.875 8.5C42.1094 8.5 44 10.3906 44 12.625V34.625C44 36.9453 42.1094 38.75 39.875 38.75H4.125C1.80469 38.75 0 36.9453 0 34.625V12.625C0 10.3906 1.80469 8.5 4.125 8.5H13.75V2.3125C13.75 1.19531 14.6094 0.25 15.8125 0.25H28.1875C29.3047 0.25 30.25 1.19531 30.25 2.3125V8.5H39.875ZM16.5 3V8.5H27.5V3H16.5ZM41.25 34.625V22.25H27.5V25.6875C27.5 26.8906 26.5547 27.75 25.4375 27.75H18.5625C17.3594 27.75 16.5 26.8906 16.5 25.6875V22.25H2.75V34.625C2.75 35.3984 3.35156 36 4.125 36H39.875C40.5625 36 41.25 35.3984 41.25 34.625ZM19.25 25H24.75V22.25H19.25V25ZM41.25 19.5V12.625C41.25 11.9375 40.5625 11.25 39.875 11.25H4.125C3.35156 11.25 2.75 11.9375 2.75 12.625V19.5H41.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectIcons);
export default __webpack_public_path__ + "static/media/projectIcons.de95eaefa79591b9b1e5e4cfa45c9428.svg";
export { ForwardRef as ReactComponent };